import { notify } from '@eleveo/components-react';
import { AxiosInstance } from 'axios';
import { useQuery } from 'react-query';

import { ErrorHandlerFunction } from './types';
import { useDataProvider } from '../app/DataProvider';
import { EndpointsFactory } from '../constants/integrationConstants';

export const EVENTS_ROOT_KEY = 'events';

const fetchEvents = (client: AxiosInstance, fromDateTime: string) => () => {
  return EndpointsFactory.getEvents(client, fromDateTime);
};

export const handleEventsErrors: ErrorHandlerFunction = (queryKey, t) => {
  const isEventsError = Array.from(queryKey)[0] === EVENTS_ROOT_KEY;
  if (isEventsError) {
    notify.error(t('layout.failedToLoad'));
  }

  return isEventsError;
};

/**
 * @param fromDateTime - Date from which to get events in ISOString format. For example: `2000-03-08T14:30:57.171Z`.
 */
export function useEventsQuery(fromDateTime: string) {
  const { client } = useDataProvider();
  return useQuery(EVENTS_ROOT_KEY, fetchEvents(client, fromDateTime));
}
